import type {
  BuilderStudioDevice,
  BuilderStudioInspectorState,
  BuilderStudioModel,
} from "./types";

export const BUILDER_STUDIO_DEVICE_WIDTHS = {
  desktop: null,
  tablet: 768,
  mobile: 390,
} as const satisfies Record<BuilderStudioDevice, number | null>;

export function builderStudioDeviceWidth(
  device: BuilderStudioDevice,
): number | null {
  return BUILDER_STUDIO_DEVICE_WIDTHS[device];
}

export function builderStudioFrameWidth(
  device: BuilderStudioDevice,
): number | "100%" {
  // Desktop stays fluid, but still needs its own browsing context so viewport
  // units and media queries follow the canvas after inspector space is reserved.
  return builderStudioDeviceWidth(device) ?? "100%";
}

export function builderStudioFrameMountNodeForDevice<T>(
  _device: BuilderStudioDevice,
  mountNode: T | null,
): T | null {
  return mountNode;
}

export type BuilderStudioModelPatch = Omit<
  Partial<BuilderStudioModel>,
  "inspector"
> & {
  inspector?: Partial<BuilderStudioInspectorState>;
};

/**
 * Applies a controlled model patch without replacing untouched inspector
 * state. This keeps host adapters from duplicating nested-state merge logic.
 */
export function patchBuilderStudioModel(
  model: BuilderStudioModel,
  patch: BuilderStudioModelPatch,
): BuilderStudioModel {
  return {
    ...model,
    ...patch,
    inspector: patch.inspector
      ? {
          ...model.inspector,
          ...patch.inspector,
        }
      : model.inspector,
  };
}
